import React from 'react';
import { mdiAlertCircleOutline } from '@mdi/js';
import PropTypes from 'prop-types';
import {
  BoxRecipe,
  AlertContainer,
  RecipeTitle,
  RecipeTop,
  TextData,
  TitleMessage,
  RecipeData,
} from './styles';
import { MdIcon } from '~/shared/components';

const CardRecipe = ({ tokenRef, isControlled, showingData }) => {
  return (
    <BoxRecipe>
      <RecipeTop>
        <RecipeTitle>
          Dados{' '}
          {tokenRef.length < 10 && isControlled
            ? 'da receita'
            : 'do atendimento'}
        </RecipeTitle>
        {isControlled && (
          <AlertContainer>
            <MdIcon size={0.8} icon={mdiAlertCircleOutline} color="red" />
            <TitleMessage>Receituário controlado</TitleMessage>
          </AlertContainer>
        )}
      </RecipeTop>
      <RecipeData>
        <TextData marginBottom="10px">
          Paciente: <strong>{showingData?.patientName ?? '********'}</strong>
        </TextData>
        <TextData marginBottom="10px">
          Médico:{' '}
          <strong>
            {showingData?.doctorArticle}
            {showingData?.doctorName ? ` ${showingData.doctorName}` : '*******'}
          </strong>
        </TextData>
        <TextData marginBottom="none">
          Data da consulta: <strong>{showingData?.date ?? '** ** ****'}</strong>
        </TextData>
      </RecipeData>
    </BoxRecipe>
  );
};

CardRecipe.propTypes = {
  tokenRef: PropTypes.any.isRequired,
  isControlled: PropTypes.any.isRequired,
  showingData: PropTypes.any.isRequired,
};

export default CardRecipe;
